const SquareDownRight = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  ...props
}) => (
  <svg
    {...props}
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill="#292D32"
    />
    <path
      d="M14.8298 14.0901H10.5898C10.1798 14.0901 9.83984 13.7501 9.83984 13.3401C9.83984 12.9301 10.1798 12.5901 10.5898 12.5901H14.0798V9.1001C14.0798 8.6901 14.4198 8.3501 14.8298 8.3501C15.2398 8.3501 15.5798 8.6901 15.5798 9.1001V13.3401C15.5798 13.7601 15.2398 14.0901 14.8298 14.0901Z"
      fill="#292D32"
    />
    <path
      d="M14.8299 14.0901C14.6399 14.0901 14.4499 14.0201 14.2999 13.8701L8.63986 8.21013C8.34986 7.92013 8.34986 7.44012 8.63986 7.15012C8.92986 6.86012 9.40986 6.86012 9.69986 7.15012L15.3599 12.8101C15.6499 13.1001 15.6499 13.5801 15.3599 13.8701C15.2099 14.0201 15.0199 14.0901 14.8299 14.0901Z"
      fill="#292D32"
    />
    <path
      d="M12 18.2302C9.88995 18.2302 7.76995 17.8902 5.75995 17.2202C5.36995 17.0902 5.15995 16.6602 5.28995 16.2702C5.41995 15.8802 5.84996 15.6602 6.23996 15.8002C9.95996 17.0402 14.05 17.0402 17.77 15.8002C18.16 15.6702 18.59 15.8802 18.72 16.2702C18.85 16.6602 18.64 17.0902 18.25 17.2202C16.23 17.9002 14.11 18.2302 12 18.2302Z"
      fill="#292D32"
    />
  </svg>
);
export default SquareDownRight;
